module.exports = __webpack_public_path__ + "static/media/squared.5fe7e919.jpg";